<template>
  <div class="route-view has-top dark">
    <wallet />

    <ranking-timeline
      v-if="rankingRanks.length"
      :ranks="rankingRanks"
      :current-rank-index="rankingCurrentRankIndex"
      :active-rank-index="rankingCurrentRankIndex"
      :redirect-on-click="true"
      @area-click="goToRanking"
    />

    <div v-for="item in sortedArrs" :key="item.name">
      <SeamlessAccount v-if="item.name === 'seamless'" />
      <CarouselAccount
        v-if="item.name === 'slotAccount'"
        type="slotAccount"
        :modalSlot="modalSlot"
      />
      <CarouselAccount
        v-if="item.name === 'sportAccount'"
        type="sportAccount"
        :modalSlot="modalSlot"
      />
      <CarouselAccount
        v-if="item.name === 'lottoAccount'"
        type="lottoAccount"
        :modalSlot="modalSlot"
      />
    </div>

    <modal-slot-account
      v-if="modalSlotActive"
      :is-active="modalSlotActive"
      :selected-slot="selectedSlot"
      :wallet="total"
      @closeModal="modalSlotAndRefresh(true)"
    />
    <modal-agreement
      v-if="modalAgreementActive"
      :is-active="modalAgreementActive"
      @closeModal="modalAgreement"
    />
  </div>
</template>

<script>
import _ from 'lodash'

import { mapActions, mapState } from 'vuex'
import { isRememberAgreement } from '@/utils/agreement'

import ModalSlotAccount from '@/views/user/components/modals/SlotAccount'
import ModalAgreement from '@/views/user/components/modals/Agreement'

import SeamlessAccount from '@/components/SeamlessAccount.vue'
import CarouselAccount from '@/components/CarouselAccount.vue'
import Wallet from '@/components/Wallet.vue'

import RankingTimeline from '@/components/RankingTimeline'
import apiRanking from '@/api/ranking'

export default {
  name: 'UserHome',
  components: {
    ModalSlotAccount,
    ModalAgreement,
    Wallet,
    SeamlessAccount,
    CarouselAccount,
    RankingTimeline
  },
  props: {
    page: String
  },
  data() {
    return {
      selectedSlot: {},
      modalSlotActive: false,
      modalAgreementActive: false,
      rankingRanks: [],
      rankingCurrentRankIndex: 0
    }
  },
  computed: {
    ...mapState({
      total: store => store.userInfo.total
    }),
    sortedArrs() {
      let items = [
        { name: 'seamless', order: 1 },
        { name: 'slotAccount', order: 2 },
        { name: 'sportAccount', order: 3 },
        { name: 'lottoAccount', order: 4 }
      ]

      const { VUE_APP_SEAMLESS_ORDER } = process.env
      if (VUE_APP_SEAMLESS_ORDER) {
        const findIndex = _.findIndex(items, { name: 'seamless' })
        if (findIndex > -1) {
          items[findIndex].order = parseInt(VUE_APP_SEAMLESS_ORDER)
        }
      }

      items.sort((a, b) => a.order - b.order)

      return items
    }
  },
  created() {
    this.$emit('childinit', this.page)
    this.fetchRanking()
  },
  mounted() {
    if (!isRememberAgreement()) {
      setTimeout(() => {
        this.modalAgreementActive = true
      }, 1500)
    }
  },
  methods: {
    ...mapActions('userInfo', ['getUserWallet']),
    modalSlot(slot) {
      this.modalSlotActive = !this.modalSlotActive
      this.disabledBodyScroll(this.modalSlotActive)

      if (slot) this.selectedSlot = slot
      else this.selectedSlot = {}
    },
    modalSlotAndRefresh(isSaved) {
      this.modalSlot()

      if (isSaved === true) {
        this.getUserWallet(true)
      }
    },
    modalAgreement() {
      this.modalAgreementActive = !this.modalAgreementActive
      this.disabledBodyScroll(this.modalAgreementActive)
    },
    disabledBodyScroll(isModalShow) {
      if (isModalShow) document.documentElement.style.overflow = 'hidden'
      else document.documentElement.style.overflow = 'auto'
    },
    goToRanking() {
      this.$router.push('ranking')
    },
    async fetchRanking() {
      try {
        const data = await apiRanking.getCurrent()
        if (!data) return
        const milestones = data.milestones || []
        this.rankingRanks = milestones.map(m => ({
          id: m._id,
          order: m.order,
          name: m.name || `Milestone ${m.order}`,
          shortName: (m.name || `M${m.order}`).split(' ')[0].substring(0, 8),
          image: m.image || null,
          color: m.color || null,
          isClaimed: m.isClaimed,
          isReached: m.isReached
        }))
        const nextGoal = this.rankingRanks.findIndex(r => !r.isReached)
        this.rankingCurrentRankIndex =
          nextGoal !== -1 ? nextGoal : this.rankingRanks.length - 1
      } catch (e) {
        // silently ignore — timeline just won't show
      }
    }
  }
}
</script>
